module.exports = __webpack_public_path__ + "media/application/images/svgs/sbt-8828a4d4f650535e6987044b7b3c6bf5.svg";